@if (paymentSignal(); as payment) {
  <ion-label>
    <h3>
      <div class="flex flex-row justify-between">
        <div>
          {{ studentSignal()?.forename }}
          {{ studentSignal()?.surname }}
        </div>
        <div>CHF {{ payment.amount | number: "1.2-2" }}</div>
      </div>
    </h3>
    <div>
      <div>
        <div class="flex flex-row justify-between items-center mt-2">
          <p class="text-gray-500">
            {{ payment.created_at | date : "dd.MM.yyyy" }}
          </p>
          <ion-badge [color]="payment.payment_method === 'Bar' ? 'light' : 'primary'" mode="ios">{{
            payment.payment_method
          }}</ion-badge>
        </div>
      </div>
    </div>
  </ion-label>
}